import { ArticleItemBody } from '#components/Article/Items/ArticleItemBody';
import { ArticleItemImage } from '#components/Article/Items/ArticleItemImage';
import { ArticleItemTeaserText } from '#components/Article/Items/ArticleItemTeaserText';
import { ArticleItemTitleLink } from '#components/Article/Items/ArticleItemTitleLink';
import { ImageModule } from '#components/Image/ImageModule';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import type { BoardTeaser } from '#domains/resolver/board-section-data';
import { IconSystem } from '#icons/IconSystem';
import { TrackEventDataType } from '#types/tracking';
import { Tracktor } from 'react-tracktor';

import styles from './BoardSectionItemBoard.module.scss';

type Props = {
	teaser: BoardTeaser;
	isLarge?: boolean;
	sizes: string;
};

export function BoardSectionItemBoard({ teaser, isLarge, sizes }: Props) {
	const {
		constants: { appUrl },
	} = useEnvironment();

	const imageComp = <ImageModule image={teaser.media} enableZoomEffect={true} sizes={sizes} />;

	return (
		<Tracktor
			trackingData={{
				data: {
					target: {
						title: teaser.title,
						url: `${appUrl}${teaser.link}`,
					},
					type: TrackEventDataType.BoardClick,
				},
			}}
		>
			{({ trackEvent }) => (
				<article className={`${styles.wrapper} ${isLarge ? styles.isLargeWrapper : ''}`} onClick={() => trackEvent({})}>
					<header className={styles.header}>
						<ArticleItemImage image={imageComp} path={teaser.link} title={teaser.title} />
					</header>

					<ArticleItemBody className={styles.body}>
						<section className={styles.metaModules}>
							<IconSystem icon="distribution" variant="filled" title="Übersichtsseite" />
						</section>

						<ArticleItemTitleLink className={styles.title} headingClassName="heading1" path={teaser.link}>
							{teaser.title}
						</ArticleItemTitleLink>
						<ArticleItemTeaserText>{teaser.teaserText}</ArticleItemTeaserText>
					</ArticleItemBody>
				</article>
			)}
		</Tracktor>
	);
}
